import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { CreateUserRecord } from "./CreateUserRecord";
import { CreateBusinessRecord } from "./CreateBusinessRecord";
import SeedBusinessRecord from "./SeedBusinessRecord";
import { getCompleteCollection } from "../dynamicFields/getCompleteCollection";
import { createSubCollectionInClient } from "../dynamicFields/createSubCollectionInClient";
import SeedUserRole from "./SeedUserRole";

const provider = new GoogleAuthProvider();
const auth = getAuth();

const onSocialAuthSuccess = async (result) => {
  const { user, additionalUserInfo } = result;
  // The signed-in user info.
  const { accessToken, uid, phoneNumber } = user;

  if (additionalUserInfo.isNewUser) {
    /**
     * If this social auth provider is used first by the user
     * an instance of the user will be stored in the server
     */
    const record = {
      uid,
      phoneNumber: phoneNumber || "",
    };
    await CreateUserRecord(record, additionalUserInfo);
    await CreateBusinessRecord(record, additionalUserInfo);
  }

  /**
   * Get business information and seed in localstorage
   */
  await SeedBusinessRecord(uid);

  /**
   * Get user role and seed in localstorage
   */
  await SeedUserRole(uid);

  /**
   * Setting Predefined custom fields in clients collection
   */
  await createSubCollectionInClient(await getCompleteCollection());

  return result;
};

export default onSocialAuthSuccess;
